import { HeroMenu } from "./hero-section/HeroMenu"
import { Carousel } from "./hero-section/Carousel"
import "./heroSection.css"

export function HeroSection() {

    return (
        <div className="mx-auto gap-5 hero-section">

            <div className="searchbar flx-lg-off justify-content-between align-items-center on">
                <input
                    className="search-field w-100"
                    placeholder="What are you looking for?"
                />
                <div className="search-icon">
                </div>
            </div>

            <HeroMenu />
            <Carousel />
        </div>
    )
}